'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "FooterHelp": "Polaris-FooterHelp"
};

exports.default = styles;
